import React, { useEffect, useState } from "react"
import { makeStyles } from "@mui/styles"
import OrderHeader from "./OrderHeader"
import OrderFooter from "./OrderFooter"
import OrderInfosAction from "./OrderInfosAction"
import {
    orderMode,
    computeCartData,
} from "../../../utils/ordersUtils"
import OrderCartListView from "./OrderCartListView"

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%"
    },
    mainBloc: {
        flex: "1 1 auto",
        overflow: "scroll"
    }
})

const OrderCartList = (props) => {
    const {
        mode,
        order,
        cart,
        actions,
        selectedSupplier,
        expectedDeliveryDate,
        isValidOrder,
        onValidateOrder
    } = props
    
    const classes = useStyles()
    
    const [cartData, setCartData] = useState(computeCartData(cart))

    useEffect(() => {
        const computedCartData = computeCartData(cart)
        setCartData(computedCartData)
    }, [cart])

    return (
        <div className={classes.container}>
            <OrderHeader
                mode={mode}
                order={order}
            />
            <div className={classes.mainBloc}>
                <OrderCartListView
                    order={order}
                    cart={cart}
                    mode={mode}
                    actions={actions}
                    isValidOrder={isValidOrder}
                />
            </div>
            {
                mode === orderMode.UPDATE &&
                    <OrderFooter
                        mode={mode}
                        selectedOrder={order}
                        totalPrice={cartData.price}
                        totalWeight={cartData.weight}
                        shippingFees={selectedSupplier && selectedSupplier.order && selectedSupplier.order.shippingFees ? selectedSupplier.order.shippingFees : ""}
                        expectedDeliveryDate={expectedDeliveryDate}
                        actions={actions}
                        order={selectedSupplier.order}
                        updateValidatedOrder={onValidateOrder}
                    />
            }
            <OrderInfosAction
                mode={mode}
                actions={actions}
                cart={cart}
                isValidOrder={isValidOrder}
                order={order}
            />
        </div>
    )
}

export default OrderCartList